<rask-header [uppercase]="true">
    SKS-Anmälan
</rask-header>
<rask-container-block>
    <ng-container header>Skapa/uppdatera koppling mellan åtgärd och avverkningsanmälan</ng-container>
    <rask-input label="Ange åtgärdsbeteckning" (change)="newSearch()" [(ngModel)]="atgardsBeteckning"></rask-input>
    <ng-container footer>
        <rask-button color="secondary" (click)="updateAvverkningsanmalan()">Hämta</rask-button>
    </ng-container>
</rask-container-block>
<rask-response-panel
[show]="searchedForAtgard"
label="Resultat för åtgärd: ({{atgardsBeteckning}})"
message="{{operationResult.message}}">
</rask-response-panel>
